<template>
  <el-table :data="rateDataTable" stripe style="width: 100%" ref="rateDataTable" border
            v-loading="listLoading">
    <af-table-column prop="id" label="费率模型ID"></af-table-column>
    <af-table-column prop="ruleName" label="费率名称"></af-table-column>
    <af-table-column prop="operatorName" label="所属运营商"></af-table-column>
    <af-table-column label="电费">
      <template  slot-scope="scope">
        <div v-if="scope.row.typeCode === 'standard' && scope.row.pileType == 'Q' ">
          <span style="color: #2fff00;" class="span_one">●</span><span
          v-html="' 常规电费 : ' + scope.row.standardElectricityFees + ' 元/kW·h'"></span>
        </div>
        <div v-else-if="scope.row.typeCode === 'times'">
          <span style="color: #409EFF;" class="span_one">●</span><span
          v-html=" (scope.row.pileType == 'Q'?' 尖电费 : ':'第一阶段功率') + scope.row.topElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
          <span style="color:  #43c26e" class="span_one">●</span><span
          v-html=" (scope.row.pileType == 'Q'?' 峰电费 : ':'第二阶段功率') + scope.row.summitElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
          <span style="color: #ff4d4d" class="span_one">●</span><span
          v-html=" (scope.row.pileType == 'Q'?' 平电费 : ':'第三阶段功率') + scope.row.flatElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
          <span style="color: #ffbc2e" class="span_one">●</span><span
          v-html=" (scope.row.pileType == 'Q'?' 谷电费 : ':'第往后阶段功率') + scope.row.valleyElectricityFees + (scope.row.pileType == 'Q'?' 元/kW·h':'W')"></span><br/>
        </div>
      </template>
    </af-table-column>
    <af-table-column prop="serviceFees" label="服务费">
      <template slot-scope="scope">
        <div v-if="scope.row.typeCode === 'standard'">
          <span style="color: #2fff00;" class="span_one">●</span><span
          v-html="' 常规服务费 : ' + scope.row.standardServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span>
        </div>
        <div v-else-if="scope.row.typeCode === 'times'">
          <span style="color: #409EFF;" class="span_one">●</span><span
          v-html="(scope.row.pileType == 'Q'?' 尖服务费 : ':'第一阶段服务费') + scope.row.topServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
          <span style="color:  #43c26e" class="span_one">●</span><span
          v-html="(scope.row.pileType == 'Q'?' 峰服务费 : ':'第二阶段服务费') + scope.row.summitServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
          <span style="color: #ff4d4d" class="span_one">●</span><span
          v-html="(scope.row.pileType == 'Q'?' 平服务费 : ':'第三阶段服务费') + scope.row.flatServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
          <span style="color: #ffbc2e" class="span_one">●</span><span
          v-html="(scope.row.pileType == 'Q'?' 谷服务费 : ':'往后阶段服务费') + scope.row.valleyServiceFees +  (scope.row.pileType == 'Q'?' 元/kW·h':'元/分钟')"></span><br/>
        </div>
      </template>
    </af-table-column>
    <af-table-column prop="discountRate" label="折扣率"></af-table-column>
    <af-table-column prop="electricLossRate" label="电损比率"></af-table-column>
    <af-table-column label="操作" width="160px">
      <template slot-scope="scope">
        <!--                    <el-button size="mini" plain @click="rateDetail(scope.$index, scope.row)">详情</el-button>-->
        <el-button size="mini" @click="rateEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:rate:editRate'])">编辑
        </el-button>
        <el-button size="mini" type="danger" @click="rateDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:rate:deleteRate'])">删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      rateDataTable:{},
      listLoading:false,
    },
    methods:{
      rateEdit(index,row){
        this.$emit("rateEdit",index,row)
      },
      rateDelete(index,row){
        this.$emit("rateDelete",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/list.vue